import React, { useEffect } from 'react'

import { MessagePanel, BodyText, Label, Button } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { withRouter } from 'react-router-dom'

import { ACCOUNT_ROUTES, TRACKING_EVENTS } from 'App/constants'
import useTracking from 'hooks/useTracking'

import styles from './FailedMessages.scss'

const FailedMessages: React.FC<any> = ({ history }) => {
  const trackMessagesError = useTracking(TRACKING_EVENTS.messagesError.id)
  const errorMessageText = getLabelFromStorage(
    'omni.myaccount.inbox.optedin.error.explanation.part1',
  )

  useEffect(() => {
    trackMessagesError({
      event_label: errorMessageText,
    })
  }, [])

  return (
    <MessagePanel title={<Label copyKey="omni.myaccount.inbox.optedin.error.heading" />}>
      <BodyText>
        <Label copyKey="omni.myaccount.inbox.optedin.error.explanation.part1" />
      </BodyText>
      <BodyText>
        <Label copyKey="omni.myaccount.inbox.optedin.error.explanation.part2" />
      </BodyText>
      <BodyText>
        <Label copyKey="omni.myaccount.inbox.optedin.error.explanation.part3" />
      </BodyText>
      <Button className={styles.button} onClick={() => history.push(ACCOUNT_ROUTES.HMPay.path)}>
        <Label copyKey="omni.myaccount.inbox.optedin.error.link" />
      </Button>
    </MessagePanel>
  )
}

export default withRouter(FailedMessages)
